"use client";

import { useEffect, useState } from "react";

import { ScreenersTable } from "@/components/table/views/screeners";
import { useUserContext } from "@/context/user.context";
import { useTrackAnalytics } from "@/hooks/analytics.hooks";

const ActiveScreenersPage = () => {
  const [userTracked, setUserTracked] = useState(false);
  const track = useTrackAnalytics();
  const { user } = useUserContext();

  useEffect(() => {
    if (!userTracked && user) {
      setUserTracked(true);
      track("Screener Admin Home Viewed");
    }
  }, [userTracked, track, user]);

  return <ScreenersTable />;
};

export default ActiveScreenersPage;
